<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Dashboard</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <p class="mb-8 leading-normal">Selamat Datang! Berikut adalah hasil summary dari data yang terdapat pada aplikasi.</p>
      <div class="row">
        <div class="col-sm-6 col-lg-3" v-for="(row, i) in dashboard" :key="`dashboard-${i}`">
          <div class="card total text-light" :style="`background-color: ${row.color}`">
            <div class="card-body">
              <Icon :icon="row.icon" />
              <h2 class="card-title fs-1" v-text="row.val"></h2>
              <p class="card-text fw-bold" v-text="row.label"></p>
              <!---->
            </div>
            <div class="card-footer d-flex justify-content-between cp">
              <p class="m-0">Selengkapnya</p>
              <Icon :icon="['fa', 'arrow-alt-circle-right']" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import layout from '@/layout/Index'
export default {
  layout,
  data() {
    return {
      dashboard: [
        {
          label: 'Total Usulan',
          icon: ['fa', 'wand-magic-sparkles'],
          color: '#990099',
          val: '0'
        },
        {
          label: 'Alokasi Dana',
          icon: ['fa', 'wallet'],
          color: '#3B3EAC',
          val: '0'
        },
        {
          label: 'Total Domisili',
          icon: ['fa', 'map-location-dot'],
          color: '#22AA99',
          val: '10'
        },
        {
          label: 'Jumlah Komoditi',
          icon: ['fa', 'layer-group'],
          color: '#316395',
          val: '13'
        },
        {
          label: 'Persentase Pengisian',
          icon: ['fa', 'square-pen'],
          color: '#DC3912',
          val: '16.78%'
        },
        {
          label: 'Total Indikator',
          icon: ['fa', 'table-cells'],
          color: '#FF9900',
          val: '1641'
        }
      ]
    }
  },
  mounted() {
    if([1].includes(this.$page.props.auth.user.role.id)) {
      this.dashboard.push({
        label: 'Total Pengguna',
        icon: ['fa', 'users'],
        color: '#109618',
        val: '1'
      });
    }
  }
}
</script>
